import { createCustomer } from '@/ducks/customerReducer'
import { get, post } from '@/util/auth'

import {
  API_ROUTE_COST_OBJECTS,
  API_ROUTE_CUSTOMER,
  API_ROUTE_FRAME_AGREEMENT,
  API_ROUTE_FRAME_AGREEMENT_APPLICATION,
  API_ROUTE_POLICIES,
} from './apiRoutes'

export const getCustomerAPI = async (customerId: number) => {
  const response = await get(API_ROUTE_CUSTOMER.replace(':customer_id', String(customerId)))

  return transformCustomerForWS(response)
}

const transformCustomerForWS = (customer: any) =>
  createCustomer({
    orgNumber: customer.org_no,
    status: customer.status,
    vatNumber: customer.vat_no,
    numberOfEmployees: customer.number_of_employees,
    customerHeadId: customer.customer_head_id,
    customerHeadName: customer.customer_head_name,
    applicationFileId: customer.application_file_id,
    applicationFileName: customer.application_file_name,
    applicationFileCreated: customer.application_file_created,
    contactName: customer.contact_name,
    contactPhone: customer.contact_phone,
    contactMobile: customer.contact_mobile,
    contactEmail: customer.contact_email,
    address1: customer.address1,
    address2: customer.address2,
    zip: customer.zip,
    city: customer.city,
    ...customer,
  })

export const getCostObjectsAPI = (customerId: number) =>
  get(API_ROUTE_COST_OBJECTS.replace(':customer_id', String(customerId)))

export const postCostObjectsAPI = async ({
  customerId,
  costObject,
}: {
  customerId: number
  costObject: unknown
}) => {
  const response = await post(
    API_ROUTE_COST_OBJECTS.replace(':customer_id', String(customerId)),
    costObject
  )

  return transformCustomerForWS(response)
}

export const getPoliciesAPI = (customerId: number) =>
  get(API_ROUTE_POLICIES.replace(':customer_id', String(customerId)))

export const getFrameAgreementAPI = (customerId: number) =>
  get(API_ROUTE_FRAME_AGREEMENT.replace(':customer_id', String(customerId)))

export const postFrameAgreementApplicationAPI = ({
  customerId,
  form,
  rates,
}: {
  customerId: number
  form: unknown
  rates: unknown
}) =>
  post(API_ROUTE_FRAME_AGREEMENT_APPLICATION.replace(':customer_id', String(customerId)), {
    form,
    rates,
  })
